export default __webpack_public_path__ + "static/media/appgallery-disabled.080c1042.svg";